wbApp.factory('bankSvc', ['$resource', 'repositorySvc', '$q',
    function ($resource, repositorySvc, $q) {

        var Bank = $resource('/Api/Bank/GetAll', {}, {
            'query': { method: 'GET', isArray: true },
            'getAllByAccountingBookID': { method: 'GET', isArray: true, url: '/Api/Bank/GetAllByAccountingBookID' },
            'getUnimportantByAccountingBookID': { method: 'GET', isArray: true, url: '/Api/Bank/GetUnimportantByAccountingBookID' },
            'requestPairing': { method: 'POST', isArray: false, url: '/Api/Bank/RequestPairing' },
            'removePairing': { method: 'POST', isArray: false, url: '/Api/Bank/RemovePairing' },
            'markAsUnimportant': { method: 'POST', isArray: false, url: '/Api/Bank/MarkAsUnimportant' },
            'restoreUnimportant': { method: 'POST', isArray: false, url: '/Api/Bank/RestoreUnimportant' },

        });

        function getAllByAccountingBookID(accountingBookID, fromDate, toDate) {
            return repositorySvc.customGet('getAllByAccountingBookID', Bank, {
                accountingBookID: accountingBookID,
                fromDate: fromDate,
                toDate: toDate
            });
        }

        function getUnimportantByAccountingBookID(accountingBookID, fromDate, toDate) {
            return repositorySvc.customGet('getUnimportantByAccountingBookID', Bank, {
                accountingBookID: accountingBookID,
                fromDate: fromDate,
                toDate: toDate
            });
        }

        function requestPairing(accountingBookID) {
            return $q(function (resolve, reject) {
                repositorySvc.customPostWithParams(
                    'requestPairing',
                    Bank, {
                        accountingBookID: accountingBookID  
                    },
                    null,
                    resolve,
                    reject
                )
            });
        }

        function removePairing(accountingBookID, transactionID, removePayment) {
            return $q(function (resolve, reject) {
                repositorySvc.customPost(
                    'removePairing',
                    Bank, {
                        accountingBookID: accountingBookID,
                        transactionID: transactionID,
                        removePayment: removePayment
                    },
                    resolve,
                    reject
                )
            });
        }

        function markAsUnimportant(accountingBookID, transactionID) {
            return $q(function (resolve, reject) {
                repositorySvc.customPost(
                    'markAsUnimportant',
                    Bank, {
                        accountingBookID: accountingBookID,
                        transactionID: transactionID
                    },
                    resolve,
                    reject
                )
            });
        }

        function restoreUnimportant(accountingBookID, accountingBookTransactionIDs) {
            return $q(function (resolve, reject) {
                repositorySvc.customPost(
                    'restoreUnimportant',
                    Bank, {
                        accountingBookID: accountingBookID,
                        accountingBookTransactionIDs: accountingBookTransactionIDs
                    },
                    resolve,
                    reject
                )
            });
        }

        return {
            getAllByAccountingBookID: getAllByAccountingBookID,
            getUnimportantByAccountingBookID: getUnimportantByAccountingBookID,
            requestPairing: requestPairing,
            removePairing: removePairing,
            markAsUnimportant: markAsUnimportant,
            restoreUnimportant: restoreUnimportant
        }
    }]);